import React from "react";
import { Link } from "react-router-dom";

/**
 * Finance breadcrumb trail. Always roots at "Finance"; pass the trailing crumbs.
 *
 *   <FinanceBreadcrumb items={[{ label: "Chart of Accounts" }]} />
 *   -> Finance / Chart of Accounts
 *
 *   <FinanceBreadcrumb items={[
 *     { label: "Accounts Payable", to: "/accountant/liabilities/payables" },
 *     { label: "Record Payment" },
 *   ]} />
 *
 * The last crumb (or any without a `to`) renders as plain current-page text.
 */
export default function FinanceBreadcrumb({ items = [] }) {
  const crumbs = [{ label: "Finance", to: "/accountant/finance/setup" }, ...items];
  return (
    <nav className="fin-breadcrumb" aria-label="breadcrumb">
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        return (
          <span key={i} className="fin-breadcrumb-item">
            {c.to && !last ? (
              <Link to={c.to} className="fin-breadcrumb-link">
                {c.label}
              </Link>
            ) : (
              <span className={last ? "fin-breadcrumb-current" : undefined}>
                {c.label}
              </span>
            )}
            {!last && <span className="fin-breadcrumb-sep">/</span>}
          </span>
        );
      })}
    </nav>
  );
}
